import { Application, Text } from "pixi.js";
import { ConfigParams } from "./GameConfig";
import GlobalStore from "./services/GlobalStore";
import SignController from "./services/SignController";
import { MessageEvents } from "./events/EventEnums";
import { DefaultSign } from "./signs/DefaultSign";
import { audioManager } from "./services/AudioManager";

class Main {
  private sign: DefaultSign;
  private showDebug: boolean = false;

  constructor({
    app,
    controller,
    config,
  }: {
    app: Application;
    controller: SignController;
    config: ConfigParams;
  }) {
    // Initialize AudioManager - this should use sounds already loaded by asset pack
    audioManager.initialize().catch((error) => {
      console.error("Failed to initialize AudioManager:", error);
    });

    this.sign = new DefaultSign({
      stage: app.stage,
      controller: controller,
      config: config,
    });

    // const testAnimation = new ImageAnimation({
    //   options: {
    //     path: "assets/animations/test",
    //     debugInfo: true,
    //     imageName: "test",
    //     frameCount: 90,
    //     // loop: false,
    //   },
    //   // containerOptions: {
    //   // boundsArea: new Rectangle(0, 0, 100, 100),
    //   // }
    // });
    // testAnimation.play();
    // testAnimation.zIndex = 99999;
    // app.stage.addChild(testAnimation);

    // const o = new OdometerExample();
    // app.stage.addChild(o);

    const disconnectText = new Text({
      text: "Connection",
      style: {
        fontFamily: "Avenir Next Condensed Demi Bold",
        fontSize: 20,
        fill: 0xffffff,
        align: "right",
        wordWrap: true,
        wordWrapWidth: 1000,
      },
    });
    disconnectText.visible = false;
    disconnectText.anchor.set(1, 0);
    disconnectText.x = config.app.screenWidth - 5;
    app.stage.addChild(disconnectText);

    GlobalStore.messageEventEmitter.on(
      MessageEvents.MESSAGE_CONNECTION_OK,
      () => {
        disconnectText.style.fill = "0x00ff00";
        disconnectText.visible = false;
      },
    );
    GlobalStore.messageEventEmitter.on(
      MessageEvents.MESSAGE_CONNECTION_WARN,
      () => {
        disconnectText.style.fill = "0xffcc00";
        disconnectText.visible = true;
      },
    );
    GlobalStore.messageEventEmitter.on(
      MessageEvents.MESSAGE_CONNECTION_ERROR,
      () => {
        disconnectText.style.fill = "0xff0000";
        disconnectText.visible = true;
      },
    );
  }
}

export default Main;
